<template lang="pug">
  div
    .addUnit__popup__return(@click="$emit('closeModal')")
      van-icon(name="cancel")
    .addUnit__popup__title {{ $t('addUnit.info.setPin') }}
    .addUnit__popup__close(@click="checkPin")
      van-icon(name="save")

    van-password-input.margin-top(
      :value="pinInput"
      :length="4"
      :info="$t('addUnit.info.security')")

    .text-danger.text--center(v-if="pinError")
      | {{ $t('addUnit.info.securityFail') }}

    van-number-keyboard(
      :show="true"
      @input="onInput"
      @delete="onDelete")
</template>

<script>
import i18n from '@/locales/i18n';
import InstallationService from '@/services/installation.service';

export default {
  name: 'DevicePin',
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pinInput: '',
      pinError: false,
    };
  },
  methods: {
    onInput(key) {
      this.pinError = false;
      this.pinInput = (this.pinInput + key).slice(0, 4);
    },

    onDelete() {
      this.pinError = false;
      this.pinInput = this.pinInput.slice(0, this.pinInput.length - 1);
    },

    async checkPin() {
      try {
        this.$toast.loading({ duration: 0, mask: true, message: i18n.t('addUnit.loading') });

        const data = {
          mac: this.device.mac,
          pin: this.pinInput,
        };

        await InstallationService.checkPin(data);
        this.$emit('success', this.pinInput);
      } catch (error) {
        this.pinError = true;
      } finally {
        this.$toast.clear();
      }
    },
  },
};
</script>
